// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGToggleDicomTagIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGToggleDicomTagIcon extends PureComponent<
  ISVGToggleDicomTagIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g id="Layer_2_1_" />
        <g id="Layer_1" display="none">
          <g id="Layer_3" display="inline" />
          <g id="Layer_1_1_" display="inline" />
          <g display="inline">
            <g>
              <g enableBackground="new    ">
                <g>
                  <polygon
                    fill="#808080"
                    points="22.983,26.572 25.719,34.699 24.783,33.241 22.538,26.572 					"
                  />
                </g>
                <g>
                  <path
                    fill="#808080"
                    d="M22.983,26.572l2.735,8.127L22.983,26.572z"
                  />
                </g>
                <g>
                  <polygon
                    fill="#B9B9B9"
                    points="21.111,22.306 22.047,23.764 12.759,23.764 13.404,22.306 					"
                  />
                </g>
                <g>
                  <path fill="#B9B9B9" d="M13.404,22.306h7.707H13.404z" />
                </g>
                <g>
                  <path
                    fill="#858585"
                    d="M18.852,13.918c0.234,0.783,1.306,4.068,3.195,9.846l-0.936-1.458
						c-1.891-5.778-2.961-9.054-3.195-9.846c-0.06-0.193-0.121-0.403-0.183-0.628c-0.006-0.023-0.01-0.036-0.013-0.048
						c0.094-0.331,0.183-0.666,0.268-1.007h0.099C18.348,12.091,18.609,13.135,18.852,13.918z"
                  />
                </g>
                <g>
                  <polygon
                    fill="#B9B9B9"
                    points="19.293,6.529 20.229,7.987 16.323,7.987 15.387,6.529 					"
                  />
                </g>
                <g>
                  <polygon
                    fill="#818181"
                    points="15.387,6.529 16.323,7.987 4.227,34.699 3.291,33.241 					"
                  />
                </g>
                <g>
                  <path
                    fill="#D4D4D4"
                    d="M20.229,7.987l9.576,26.712h-4.086l-2.735-8.127h-0.445H11.553l-3.51,8.127H4.227L16.323,7.987H20.229z
						 M12.759,23.764h9.288c-1.89-5.778-2.961-9.063-3.195-9.846c-0.242-0.783-0.504-1.827-0.765-3.141h-0.099
						c-0.085,0.341-0.174,0.676-0.268,1.007c-0.4,1.418-0.876,2.747-1.424,3.988l-2.892,6.534L12.759,23.764"
                  />
                </g>
                <g>
                  <path fill="#D4D4D4" d="M12.759,23.764h9.288H12.759z" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="Layer_3_1_" display="none">
          <g id="Layer_2" display="inline">
            <g>
              <path
                fill="#FFFFFF"
                d="M32.644,5.066c-2.632-1.967-5.074-3.755-9.536-3.965c-0.424,0.271-1.357,0.055-1.886,0.189
				c-1.122,0.283-2.2,0.598-3.207,1.038c-1.873,0.819-3.45,2.223-5.001,3.399c-0.474,0.503-0.944,1.006-1.417,1.509
				c0.078,1.344,2.878,3.11,3.87,3.774c1.443,0.966,2.972,1.848,4.813,2.452c5.048,1.663,9.859-1.563,12.552-3.584
				c0.804-0.605,1.377-1.564,2.17-2.17C34.938,6.494,33.415,5.644,32.644,5.066z M19.618,2.895c0.729-0.593,2.13-0.282,2.927-0.754
				c1.879,0.021,3.023,0.463,4.434,0.661c0.284,0.539,0.737,0.988,0.942,1.604c1.146,3.423-1.359,5.81-3.772,6.417
				C19.662,11.949,16.667,5.607,19.618,2.895z M25.09,12.709c-0.61,0.167-2.971,0.165-3.583,0c-3.03-0.814-7.091-2.934-8.59-5.189
				c-0.103-0.086-0.008,0.007-0.093-0.095c0.869-0.583,1.507-1.546,2.36-2.17c0.784-0.576,1.833-0.94,2.545-1.604
				c0.064,0,0.126,0,0.19,0c-1.78,4.294,1.221,7.422,4.625,8.211c0.452,0.103,1.204-0.026,1.509-0.096
				c2.675-0.61,3.979-1.639,4.814-4.058c0.35-1.017,0.471-3.14-0.192-3.965c0-0.03,0-0.062,0-0.095
				c2.163,0.591,3.449,2.696,5.097,3.776C32.271,9.725,28.158,11.874,25.09,12.709z"
              />
              <path
                fill="none"
                d="M24.148,10.822c2.413-0.607,4.916-2.995,3.772-6.417c-0.205-0.616-0.658-1.065-0.942-1.604
				c-1.413-0.197-2.556-0.642-4.434-0.661c-0.797,0.473-2.198,0.161-2.928,0.754C16.667,5.607,19.662,11.949,24.148,10.822z
				 M20.847,5.443c0.272-0.952,0.966-1.219,1.604-1.794c0.217-0.019,0.263-0.019,0.376-0.094c3.552-0.11,3.801,4.164,1.037,4.907
				C22.223,8.905,20.368,7.097,20.847,5.443z"
              />
              <path
                fill="#FFFFFF"
                d="M23.866,8.463c2.762-0.744,2.513-5.018-1.039-4.908c-0.113,0.077-0.159,0.077-0.376,0.095
				c-0.639,0.574-1.332,0.842-1.604,1.793C20.368,7.097,22.223,8.905,23.866,8.463z"
              />
              <path
                fill="none"
                d="M28.675,3.745c0.664,0.826,0.543,2.947,0.191,3.964c-0.834,2.419-2.142,3.447-4.813,4.058
				c-0.306,0.069-1.057,0.199-1.509,0.095c-3.404-0.787-6.405-3.917-4.625-8.211c-0.063,0-0.126,0-0.191,0
				c-0.711,0.665-1.76,1.028-2.546,1.605c-0.851,0.623-1.489,1.585-2.359,2.17c0.085,0.103-0.009,0.008,0.094,0.095
				c1.499,2.255,5.56,4.374,8.589,5.188c0.613,0.167,2.974,0.169,3.584,0c3.066-0.833,7.182-2.984,8.683-5.283
				c-1.647-1.08-2.936-3.185-5.098-3.774C28.675,3.682,28.675,3.714,28.675,3.745z"
              />
            </g>
          </g>
        </g>
        <g id="Layer_5">
          <g>
            <path
              fill="#FFFFFF"
              d="M23.789,35h-3.643l-2.86-7.418H7.107L4.414,35h-3.41l9.364-24.381h3.476L23.789,35z M16.305,25.021
			c-1.996-5.277-3.121-8.274-3.376-8.99c-0.255-0.714-0.538-1.671-0.849-2.869h-0.083c-0.311,1.641-0.726,3.16-1.248,4.557
			l-2.728,7.302H16.305z"
            />
          </g>
        </g>
        <g id="Layer_4">
          <g id="Layer_2_2_">
            <g>
              <path
                fill="#FFFFFF"
                stroke="#000000"
                strokeWidth="0.1"
                strokeMiterlimit="10"
                d="M32.664,4.353
				c-2.61-2.16-5.03-4.122-9.45-4.353c-0.421,0.297-1.345,0.061-1.869,0.208c-1.112,0.31-2.183,0.656-3.179,1.139
				c-1.856,0.899-3.418,2.439-4.958,3.731c-0.468,0.553-0.936,1.104-1.403,1.657c0.076,1.476,2.852,3.414,3.834,4.142
				c1.432,1.062,2.947,2.029,4.77,2.693c5.003,1.825,9.771-1.717,12.441-3.935C33.646,8.971,34.216,7.919,35,7.253
				C34.938,5.92,33.428,4.986,32.664,4.353z M19.756,1.969c0.722-0.651,2.109-0.309,2.901-0.828c1.86,0.023,2.995,0.509,4.392,0.726
				c0.284,0.591,0.731,1.084,0.936,1.761c1.137,3.756-1.349,6.377-3.738,7.044C19.798,11.909,16.83,4.948,19.756,1.969z
				 M25.178,12.743c-0.604,0.185-2.943,0.182-3.552,0c-3.003-0.894-7.026-3.22-8.513-5.697c-0.102-0.094-0.007,0.008-0.09-0.104
				c0.86-0.641,1.493-1.697,2.338-2.382c0.776-0.632,1.817-1.031,2.524-1.762c0.062,0,0.123,0,0.186,0
				c-1.764,4.715,1.211,8.148,4.586,9.013c0.447,0.116,1.191-0.026,1.494-0.104c2.651-0.668,3.942-1.798,4.771-4.454
				c0.346-1.116,0.468-3.446-0.19-4.352c0-0.033,0-0.068,0-0.104c2.144,0.65,3.42,2.959,5.052,4.146
				C32.297,9.467,28.22,11.825,25.178,12.743z"
              />
              <path
                fill="none"
                stroke="#000000"
                strokeWidth="0.1"
                strokeMiterlimit="10"
                d="M24.246,10.671
				c2.39-0.667,4.872-3.288,3.738-7.044c-0.204-0.676-0.651-1.17-0.936-1.761c-1.399-0.217-2.531-0.705-4.392-0.726
				c-0.792,0.519-2.18,0.177-2.902,0.828C16.83,4.948,19.798,11.909,24.246,10.671z M20.973,4.767
				c0.271-1.045,0.957-1.338,1.59-1.97c0.216-0.02,0.261-0.02,0.374-0.103c3.519-0.121,3.766,4.571,1.027,5.387
				C22.337,8.567,20.498,6.582,20.973,4.767z"
              />
              <path
                fill="#FFFFFF"
                stroke="#000000"
                strokeWidth="0.1"
                strokeMiterlimit="10"
                d="M23.965,8.083
				c2.737-0.816,2.49-5.509-1.028-5.389c-0.113,0.084-0.158,0.084-0.374,0.104c-0.633,0.63-1.319,0.924-1.59,1.969
				C20.498,6.582,22.337,8.567,23.965,8.083z"
              />
              <path
                fill="none"
                stroke="#000000"
                strokeWidth="0.1"
                strokeMiterlimit="10"
                d="M28.731,2.902
				c0.659,0.905,0.537,3.234,0.191,4.353c-0.829,2.654-2.124,3.783-4.771,4.455c-0.304,0.075-1.047,0.218-1.494,0.101
				c-3.375-0.862-6.35-4.297-4.586-9.013c-0.063,0-0.125,0-0.188,0c-0.704,0.73-1.745,1.129-2.524,1.762
				c-0.843,0.685-1.475,1.741-2.338,2.383c0.086,0.113-0.009,0.008,0.093,0.104c1.487,2.475,5.51,4.801,8.513,5.695
				c0.608,0.185,2.948,0.187,3.552,0c3.04-0.913,7.119-3.276,8.606-5.799c-1.632-1.185-2.91-3.497-5.053-4.143
				C28.731,2.833,28.731,2.868,28.731,2.902z"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
